<template>
  <el-card class="filterCard" shadow="never">
    <div v-if="title" slot="header" class="clearfix">
      <span class="title">{{title}}</span>
    </div>
    <slot></slot>
  </el-card>
</template>
<script>
export default {
  props: {
    title: {
      default: null,
      type: String
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
  .el-card.filterCard {
    background: #F5F7FA;
    border-radius:4px;
    margin-bottom: 8px;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: none;
      .title {
        color: #333333;
        font-weight: 600;
        font-size: 12px;
      }
  }
  .el-card.filterCard ::v-deep  .el-card__header {
    padding: 10px 9px;
    border-bottom: none;
    .clearfix {
      font-size: 12px;
      line-height: normal;
    }
  }
  .el-card.filterCard ::v-deep  .el-card__body {
    padding-top: 5px;
  }
</style>
